<template>
  <div class="report-graphs-section">
    <div class="graph-row">
      <most-occurring-report ref="occurring"
                             :error="occurring.error"
                             :graphData="occurring.data"
                             :wrapperWidth="occurring.width"
                             @loadGraphData="loadGraphData"></most-occurring-report>

      <div class="divider vertical"></div>

      <recipients-report ref="recipients"
                         :error="recipients.error"
                         :graphData="recipients.data"
                         :wrapperWidth="recipients.width"
                         @loadGraphData="loadGraphData"></recipients-report>
    </div>

    <div class="graph-row graph-dividers">
      <div class="divider"></div>
      <div class="divider"></div>
    </div>

    <div class="graph-row">
      <trend-line-report ref="trends"
                         :error="trends.error"
                         :graphData="trends.data"
                         :wrapperWidth="trends.width"
                         @loadGraphData="loadGraphData"></trend-line-report>

      <div class="divider vertical"></div>

      <opt-out-report ref="optout"
                      :error="optout.error"
                      :graphData="optout.data"
                      :optout="optout"
                      :wrapperWidth="optout.width"
                      @loadGraphData="loadGraphData"></opt-out-report>
    </div>

  </div>
</template>


<script>
  import axiosConfig from '../../config/axios'
  import GraphData from '../../mixins/GraphDataMixin'
  import { isObject } from '../../utilities/index'
  import MostOccurringReport from '../Reports/MostOccurringReport'
  import OptOutReport from '../Reports/OptOutReport'
  import RecipientsReport from '../Reports/RecipientsReport'
  import TrendLineReport from '../Reports/TrendLineReport'

  export default {
    props: {
      campaignId: [Number, String],
      communicationType: {
        default: 'campaigns',
        type: String
      },
      isTracked: Boolean,
      trackingDuration: null
    },

    name: 'ReportGraphs',

    components: {
      MostOccurringReport,
      OptOutReport,
      RecipientsReport,
      TrendLineReport,
    },

    mixins: [GraphData],

    data() {
      return {
        occurring: {},
        optout: {},
        optoutKeys: ['totalOptouts', 'withVisits', 'withPoints'],
        recipients: {},
        trends: {},
      }
    },

    methods: {
      configureGraphData(data, graphType) {
        const isOptout = graphType === 'optout',
              reportData = isOptout ? data.data : data,
              graphData = this.buildGraphData(reportData, graphType)
        if (isOptout) {
          this.optoutKeys.forEach(key => {
            this.$set(this.optout, key, data[key])
          })
        }
        this.getStartEndDates(reportData, graphType)
        graphType && this.$set(this[graphType], 'data', graphData)
      },

      loadGraphData(endUrl, graphType, params) {
        // graph types
        // 1) recipients
        // 2) trends
        // 3) occurring
        // 4) optout

        const url = `/api/v3/${this.communicationType}/${this.campaignId}/${endUrl}`
        let errorMessage = `we encountered an issue loading the ${graphType} graph`
        params.params.duration = this.trackingDuration
        axiosConfig.get(url, params)
          .then((response) => {
            const data = response.data
            if (isObject(data)) {
              this.configureGraphData(data.data, graphType)
              this[graphType].error && this.$delete(this[graphType], 'error')
            } else {
              this.$set(this[graphType], 'error', errorMessage)
            }
          })
          .catch((error) => {
            const customError = error.response && error.response.data ? error.response.data.error : null
            errorMessage = customError ? customError : `${errorMessage}: ${error}`
            this.$set(this[graphType], 'error', errorMessage)
          })
      },

      setWrapperWidths() {
        const view = this,
          graphTypes = ['occurring', 'optout', 'recipients', 'trends']
        graphTypes.forEach((graph) => {
          let width = view.$refs[graph].$el.offsetWidth
          view.$set(view[graph], 'width', width)
        })
      },
    },
  }
</script>
